export default __webpack_public_path__ + "static/telesan_inicio5-3388f64b9ee4c49f3aa14978118944ec.jpg";